import React from 'react';
import CheckmarkIcon from '../../../../../../assets/img/CheckmarkIcon.svg';
import PageHeader from '../../../../../../components/Layout/PageHeader/PageHeader';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const UploadConfirmation = () => {
  const { t } = useTranslation('upload');
  const navigate = useNavigate();

  const handleNavigateToUpload = () => {
    navigate('/upload');
  };

  return (
    <>
      <PageHeader />
      <div className="result-page">
        <img src={CheckmarkIcon} alt="Success" className="result-icon" />
        <p className="result-message result-message--success">
          {t('uploadConfirmation.successMessage')}
        </p>
        <button 
          className="btn btn--primary" 
          onClick={handleNavigateToUpload}
        >
          {t('uploadConfirmation.button')}
        </button>
      </div>
    </>
  );
};

export default UploadConfirmation;
